import React, { Component, PropTypes as T } from 'react'
import { connect } from 'react-redux'
import {
	setFilters,
	getSearchData,
	searchAction,
	closeSearch
} from 'actions/search'

class SearchFilters extends Component {
	constructor( props ) {
		super( props )

		this.handleFiltersChange = this.handleFiltersChange.bind( this )
		this.handleCloseClick = this.handleCloseClick.bind( this )
	}

	handleFiltersChange( e ) {
		let filter = e.target.getAttribute( 'data-filter' )
		const placeFilters = {
			'church': 'Churches',
			'school': 'Schools',
			'medical': 'Medical Centres',
			'aged_care': 'Aged Care Facilities',
			'opshop': 'Op Shops',
			'recreation': 'Camp Grounds',
			'bookstore': 'Bookstores',
			'ministry': 'Ministries',
			'service': 'Services',
			'pathfinders': 'Pathfinders',
			'adventurers': 'Adventurers',
			'administration': 'Administration'
		}
		const contentFilters = {
			'department': 'Our Entities',
			'resource': 'Resources'
		}
		let searchTerm, overrideSearchTerm = false

		if ( filter in placeFilters ) {
			overrideSearchTerm = 'Places'
		} else {
			if ( 'department' == filter && this.props.filters.department || 'resource' == filter && ! this.props.filters.resource ) {
				overrideSearchTerm = 'Resources'
			} else {
				overrideSearchTerm = 'Our Entities'
			}
		}

		searchTerm = overrideSearchTerm ? overrideSearchTerm : this.props.searchTerm

		this.props.handleFiltersChange( filter, searchTerm )

		e.preventDefault()
	}

	handleCloseClick() {
		this.props.handleCloseClick()
	}

	render() {
		const { filters } = this.props

		return (
			<div className="-filters">
				<div className="-close-text-wrap">
					<div className="-close-text" onClick={ this.handleCloseClick }>
						<i className="icon-close" aria-hidden="true"></i> <span>Close the search results</span>
					</div>
				</div>

				<span className="-searching">Searching:</span>

				<span className="-filters-h">Places</span>

				<ul>
					<li><a className={ filters.church ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="church">Churches</a></li>
					<li><a className={ filters.school ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="school">Schools</a></li>
					<li><a className={ filters.medical ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="medical">Medical Centres</a></li>
					<li><a className={ filters.aged_care ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="aged_care">Aged Care Facilities</a></li>
					<li><a className={ filters.opshop ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="opshop">Op Shops</a></li>
					<li><a className={ filters.recreation ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="recreation">Camp Grounds</a></li>
					<li><a className={ filters.bookstore ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="bookstore">Bookstores</a></li>
					<li><a className={ filters.ministry ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="ministry">Ministries</a></li>
					<li><a className={ filters.service ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="service">Services</a></li>
					<li><a className={ filters.pathfinders ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="pathfinders">Pathfinders</a></li>
					<li><a className={ filters.adventurers ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="adventurers">Adventurers</a></li>
					<li><a className={ filters.administration ? 'is-active' : '' } onClick={ this.handleFiltersChange } data-filter="administration">Administration</a></li>
				</ul>

				<a className="-algolia" href="https://www.algolia.com/" target="_blank" rel="noopener">
					<img src={ siteData.images_url + 'vendor/algolia/algolia.svg' } alt="" />
				</a>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		filters: state.search.filters,
		searchTerm: state.search.searchTerm
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleFiltersChange: ( filter, searchTerm ) => {
			dispatch( setFilters( filter ) )
			dispatch( searchAction( searchTerm ) )
			dispatch( getSearchData( searchTerm ) )
		},

		handleCloseClick() {
			dispatch( closeSearch() )
		}
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( SearchFilters )



// WEBPACK FOOTER //
// ./components/Search/SearchFilters.jsx